function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m352.503906 256c4.753906 0 9.351563 1.390625 13.3125 4.03125l55.871094 37.25c6.601562 4.390625 14.273438 6.71875 22.191406 6.71875h52.121094v-16h-52.113281c-4.75 0-9.359375-1.390625-13.320313-4.03125l-22.566406-15.046875v-268.921875h-304v48h-104v448h304v-48h104v-67.304688c.503906-.121093 1.023438-.160156 1.527344-.28125l37.214844-9.300781c8.257812-2.066406 16.753906-3.113281 25.257812-3.113281h24v-16h-24c-9.808594 0-19.617188 1.207031-29.136719 3.585938l-37.214843 9.300781c-19.128907 4.777343-39.488282 4-58.175782-2.230469l-13.480468-4.496094c-12.273438-4.089844-25.054688-6.160156-37.992188-6.160156h-69.808594c0-13.230469 10.769532-24 24-24h88c13.234375 0 24-10.769531 24-24 0-12.273438-9.296875-22.304688-21.191406-23.71875l6.566406-24.28125zm-10.105468 121.832031c12.273437 4.097657 25.058593 6.167969 37.992187 6.167969 3.882813 0 7.753906-.335938 11.609375-.710938v48.710938h-88v-26.167969c2.808594-3.238281 4.984375-7.070312 6.152344-11.40625l6.550781-24.265625c4.121094.839844 8.207031 1.839844 12.21875 3.183594zm-41.726563-9.648437-5.960937 22.0625c-1.550782 5.746094-6.789063 9.753906-12.734376 9.753906h-2.59375c-7.269531 0-13.183593-5.910156-13.183593-13.183594 0-1.167968.152343-2.320312.457031-3.441406l4.152344-15.375h25.191406c1.558594 0 3.113281.121094 4.671875.183594zm-46.441406-.183594-3.023438 11.191406c-.671875 2.480469-1.007812 5.039063-1.007812 7.625 0 10.816406 5.984375 20.167969 14.746093 25.207032l-2.511718 10.03125 15.519531 3.882812 2.488281-9.9375h1.535156c2.0625 0 4.0625-.289062 6.023438-.703125v64.703125h-272v-416h104v-48h272v242.257812l-17.304688-11.539062c-6.597656-4.390625-14.269531-6.71875-22.191406-6.71875h-.617187l33.296875-123.191406c.671875-2.480469 1.007812-5.039063 1.007812-7.625 0-16.09375-13.09375-29.183594-29.183594-29.183594h-2.59375c-13.15625 0-24.742187 8.871094-28.175781 21.574219l-22.238281 82.289062v-135.863281h-168v16h152v176h-16.550781c-8.707031 0-16.90625 2.886719-23.761719 8h-79.6875v16h62.878906l-16 16h-46.878906v16h30.886719l-13.367188 13.367188c-4.71875 4.710937-7.320312 10.984374-7.320312 17.664062 0 13.769531 11.199219 24.96875 24.976562 24.96875 2.464844 0 4.839844-.472656 7.144531-1.160156-.007812.390625-.121093.761718-.121093 1.160156 0 8.824219 7.175781 16 16 16zm61.625-56h-29.910157l33.78125-124.992188 27.441407 9.144532zm-61.375-48.976562c4.472656-4.464844 10.65625-7.023438 16.96875-7.023438h13.054687l-6.527344 24.144531c-10.121093.367188-19.609374 4.367188-26.808593 11.566407l-41.65625 41.65625c-1.671875 1.671874-3.984375 2.632812-6.34375 2.632812-4.953125 0-8.976563-4.023438-8.976563-8.96875 0-2.398438.9375-4.648438 2.632813-6.34375zm8 40c3.023437-3.023438 6.871093-5.085938 10.976562-6.160157l-4.089843 15.136719h-15.855469zm107.253906-190.390626-9.796875 36.246094-27.441406-9.144531 9.183594-33.980469c1.558593-5.746094 6.792968-9.753906 12.734374-9.753906h2.59375c7.273438 0 13.183594 5.910156 13.183594 13.183594 0 1.167968-.152344 2.320312-.457031 3.449218zm-41.414063 42.574219 27.441407 9.144531-4.417969 16.328126-27.441406-9.144532zm9.871094 140.792969c4.410156 0 8 3.59375 8 8s-3.589844 8-8 8h-5.765625l4.328125-16zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m240 80h-208v80h208zm-16 64h-176v-48h176zm0 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m64 112h16v16h-16zm0 0"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m96 112h16v16h-16zm0 0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m128 112h16v16h-16zm0 0"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m160 112h16v16h-16zm0 0"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m192 112h16v16h-16zm0 0"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m128 256h-16v32h-64v-64h48v-16h-64v96h96zm0 0"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m154.34375 178.34375-74.34375 74.34375-10.34375-10.34375-11.3125 11.3125 21.65625 21.65625 85.65625-85.65625zm0 0"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m112 424h-64v-64h48v-16h-64v96h96v-48h-16zm0 0"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m69.65625 378.34375-11.3125 11.3125 21.65625 21.65625 85.65625-85.65625-11.3125-11.3125-74.34375 74.34375zm0 0"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "m256 440h16v16h-16zm0 0"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "m152 440h88v16h-88zm0 0"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "m168 216h104v16h-104zm0 0"
});

var SvgListaDeVerificacion = function SvgListaDeVerificacion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "496pt",
    viewBox: "0 0 496 496",
    width: "496pt",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgListaDeVerificacion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lista-de-verificacion.8fd96cf3.svg";
export { ForwardRef as ReactComponent };